import {Component, OnInit, EventEmitter } from '@angular/core';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {Message} from '../Message';
import {MessagesService} from '../messages.service';
import 'rxjs/add/operator/switchMap';

@Component({
    selector: 'message',
    template: require('./message-detail.component.html'),
    providers: [MessagesService]
})

export class SuperUserMessageDetailComponent implements OnInit {    

    main_message: Message;    
    messages: Message[];
    iluminatedMessages: Message[];
    section: Number;
    user_id: Number;
    textAreaContent: string;
    router: Router;

    constructor(private _messagesService: MessagesService, _parentRouter: Router, private route: ActivatedRoute) {                    
                  
        this.main_message = {"id": Number(route.snapshot.params['mainId']), "title": "", "content": "", "creation_date": "", "date_to_show": "", "read": false, "user_sender_id": 0,
                              "user_sender_name": "", "user_receiver_id": 0, "user_receiver_name": "", "message_parent_id": 0, "childs":[], "total_messages_conversation": 0,
                              "main_parent_id": 0, "selected": false};
        this.messages = [];
        this.iluminatedMessages = [];
        this.section = Number(route.snapshot.params['section']);
        this.user_id = Number(localStorage.getItem("idUser"));
        this.router = _parentRouter;

    }

    ngOnInit() {                            
        this._messagesService.getMessageWithChilds(this.main_message).then(result => {
            this.main_message = result[0];
            this.organizeMessages(this.main_message);
            this.sortArrayByMessageId(this.messages);
            this.organizeSection(this.section);
        });

    }    

    organizeMessages(message: Message) {

        this.setMessageDateFormat(message);
        message.selected = false;
        this.messages.push(message);        

        if (message.childs.length > 0) {
            for (var i = 0; i < message.childs.length; i++) {
                this.organizeMessages(message.childs[i]);
            }
        }

    }

    setMessageDateFormat(message: Message) {                            

        var messageDate: Date = new Date(message.creation_date);
        var day: String = messageDate.getDate().toString();       
        if(day.length < 2) {
            day = "0" + day;
        }         
        var month: String = (messageDate.getMonth() + 1).toString();
        if(month.length < 2) {
            month = "0" + month;
        }
        var year: String = messageDate.getFullYear().toString();        
        var hour: String = messageDate.getHours().toString();
        if(hour.length < 2) {
            hour = "0" + hour;
        }
        var minute: String = messageDate.getMinutes().toString();
        if(minute.length < 2) {
            minute = "0" + minute;
        }
        var seconds: String = messageDate.getSeconds().toString();
        if(seconds.length < 2) {
            seconds = "0" + seconds;
        }                
        
        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;        

    }        

    sortArrayByMessageId(array: Message[]) {

        array.sort(function(a,b){
  
            return a.id - b.id;
        
        });

    }

    organizeSection(section: Number) {

        //Read messages
        if (section == 0) {

            this.messages[this.messages.length - 1].selected = true;
            
        //Unread messages
        } else if (section == 1) {

            for (var i = 0; i < this.messages.length; i++) {

                if (this.messages[i].user_receiver_id == this.user_id && !this.messages[i].read) {

                    this.messages[i].selected = true;                    

                }

            }

            this._messagesService.putMessagesRead(this.main_message).then(result => {

                if(result == 1) {
                    
                    this.putMessagesRead(this.messages);

                }

            });

        //Sended messages
        } else if (section == 2) {

            for (var i = 0; i < this.messages.length; i++) {

                if (this.messages[i].user_sender_id == this.user_id) {

                    this.messages[i].selected = true;

                }

            }

        }

    }

    putMessagesRead(messages: Message[]) {

        for(var i = 0; i < messages.length; i++) {

            if(messages[i].user_receiver_id == this.user_id && !messages[i].read) {

                messages[i].read = true;
                this.iluminatedMessages.push(messages[i]);

            }

        }

    }    

    goBack() {
        this.router.navigate(['/superuser', 'messages']);
    }

    getColor(message: Message) {
        if(this.arrayContains(this.iluminatedMessages, message)) {
            return "#6fb3cb";
        }
    }

    arrayContains(array: any[], object: any) {        

        for(var i = 0; i < array.length; i++) {

            if(array[i] == object) {

                return true;

            }
            
        }

        return false;

    }

    messageClicked(message: Message) {        

        if (message.selected) {

            message.selected = false;

        } else {

            message.selected = true;

        }

        if(this.arrayContains(this.iluminatedMessages, message)) {

            var index = this.iluminatedMessages.indexOf(message);
            this.iluminatedMessages.splice(index, 1);

        }

    }

    sendMessage() {

        if(!this.isTextEmpty(this.textAreaContent)) {

            if (this.user_id == this.main_message.user_sender_id) {

                var userSenderId: number = this.main_message.user_sender_id;
                var userReceiverId: number = this.main_message.user_receiver_id;
                var userSenderName: string = this.main_message.user_sender_name;
                var userReceiverName: string = this.main_message.user_receiver_name;

            } else {

                var userSenderId: number = this.main_message.user_receiver_id;
                var userReceiverId: number = this.main_message.user_sender_id;
                var userSenderName: string = this.main_message.user_receiver_name;
                var userReceiverName: string = this.main_message.user_sender_name;

            }

            var message: Message = {"id": 0, "title": this.main_message.title, "content": this.textAreaContent, "creation_date": "", "date_to_show": "", "read": false,
                                    "user_sender_id": userSenderId, "user_sender_name": userSenderName, "user_receiver_id": userReceiverId, "user_receiver_name": userReceiverName,
                                    "message_parent_id": 0, "childs": [], "total_messages_conversation": 0, "main_parent_id": this.main_message.id, "selected": false};
            
            this._messagesService.postMessage(message).then(result => {

                if(result.code == 1) {
                    this.addMessage(result.insertId).then(data_void => {
                        this.sortArrayByMessageId(this.messages);
                        this.textAreaContent = "";
                    });
                }

            });

        }

    }

    isTextEmpty(text: String): boolean {

        if (text == null || text == undefined || text == "") {

            return true;

        } else {

            var trim = text.replace(/ /g, "");
            var trim = trim.replace(/\n/g, "");            

            if(trim == "") {

                return true;

            } else {

                return false;

            }

        }

    }

    addMessage(id: number): Promise<void> {

        return this._messagesService.getMessageById(id).then(result => {
            var message: Message = result[0];
            this.setMessageDateFormat(message);
            message.selected = false;
            message.childs = [];
            this.messages.push(message);
        });

    }    

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/messages/message_detail/message-detail.component.ts
 **/